const apiServerUrl = import.meta.env.VITE_API_SERVER_URL;

export const AuthService = {
  // Stores the user's logged-in status, worker number, and token
  isLoggedIn: false,
  workerNumber: null as string | null,
  token: null as string | null,

  // Initialize login state, worker number, and token from persistent storage
  initialize() {
    this.isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    this.workerNumber = localStorage.getItem('workerNumber');
    this.token = localStorage.getItem('token');
  },

  // Login process (validate credentials and store token)
  async login(username: string, password: string): Promise<boolean> {
    try {
      const response = await fetch(`${apiServerUrl}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        throw new Error('Invalid credentials');
      }
      const data = await response.json();
      if (data.success && data.token) {
        // Store login state, worker number, and token persistently
        this.isLoggedIn = true;
        this.workerNumber = username;
        this.token = data.token;

        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('workerNumber', username);
        localStorage.setItem('token', data.token);

        return true;
      }

      return false;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  },

  // Logout process
  logout() {
    this.isLoggedIn = false;
    this.workerNumber = null;
    this.token = null;

    // Clear login state, worker number, and token from storage
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('workerNumber');
    localStorage.removeItem('token');

  },

  // Authenticate user credentials
  async authenticate(username: string, password: string): Promise<boolean> {
    return this.login(username, password);
  },

  // Helper function to get the token (for use in API calls)
  getToken(): string | null {
    return this.token;
  },
};
